/**
 * AUTO-GENERATED by scripts/build-discovery-data.mjs — DO NOT EDIT BY HAND.
 * Lightweight index of the 151 real Atlas Discovery targets copied into src/atlas/data/discovery/.
 * Counts are precomputed so the dataset selector renders instantly; full snapshots load lazily on selection.
 */
export interface DiscoveryIndexEntry {
  readonly id: string;
  readonly domain: string;
  readonly generatedAt: string;
  readonly counts: {
    readonly domains: number;
    readonly ipRanges: number;
    readonly publicServices: number;
    readonly technologies: number;
    readonly securityObservations: number;
    readonly riskObservations: number;
  };
  readonly coverage: { readonly checks: number; readonly observed: number } | null;
}

export const DISCOVERY_INDEX: readonly DiscoveryIndexEntry[] = [
  {
    "id": "discovery:2u.com",
    "domain": "2u.com",
    "generatedAt": "2026-08-16T16:23:39.853Z",
    "counts": {
      "domains": 3,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:aecom.com",
    "domain": "aecom.com",
    "generatedAt": "2026-08-16T16:23:53.141Z",
    "counts": {
      "domains": 2,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:affirm.com",
    "domain": "affirm.com",
    "generatedAt": "2026-08-16T16:22:49.427Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:airtable.com",
    "domain": "airtable.com",
    "generatedAt": "2026-08-16T16:23:31.079Z",
    "counts": {
      "domains": 2,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:allbirds.com",
    "domain": "allbirds.com",
    "generatedAt": "2026-08-16T16:24:07.915Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:alloy.com",
    "domain": "alloy.com",
    "generatedAt": "2026-08-16T16:22:54.652Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:amplitude.com",
    "domain": "amplitude.com",
    "generatedAt": "2026-08-16T16:23:46.433Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:aptargroup.com",
    "domain": "aptargroup.com",
    "generatedAt": "2026-08-16T16:22:32.284Z",
    "counts": {
      "domains": 4,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 1,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:arcbest.com",
    "domain": "arcbest.com",
    "generatedAt": "2026-08-16T16:23:18.976Z",
    "counts": {
      "domains": 12,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:arraytechinc.com",
    "domain": "arraytechinc.com",
    "generatedAt": "2026-08-16T16:27:21.015Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:bechtel.com",
    "domain": "bechtel.com",
    "generatedAt": "2026-08-16T16:24:05.330Z",
    "counts": {
      "domains": 17,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:bill.com",
    "domain": "bill.com",
    "generatedAt": "2026-08-16T16:22:46.104Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:bloomenergy.com",
    "domain": "bloomenergy.com",
    "generatedAt": "2026-08-16T16:27:07.971Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:bombas.com",
    "domain": "bombas.com",
    "generatedAt": "2026-08-16T16:27:06.684Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:boozallen.com",
    "domain": "boozallen.com",
    "generatedAt": "2026-08-16T16:22:54.913Z",
    "counts": {
      "domains": 15,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 7
    }
  },
  {
    "id": "discovery:brex.com",
    "domain": "brex.com",
    "generatedAt": "2026-08-16T16:22:46.408Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:brooklinen.com",
    "domain": "brooklinen.com",
    "generatedAt": "2026-08-16T16:27:06.513Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:casper.com",
    "domain": "casper.com",
    "generatedAt": "2026-08-16T16:27:06.529Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:cbiz.com",
    "domain": "cbiz.com",
    "generatedAt": "2026-08-16T16:22:59.311Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:chargepoint.com",
    "domain": "chargepoint.com",
    "generatedAt": "2026-08-16T16:27:08.028Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:chegg.com",
    "domain": "chegg.com",
    "generatedAt": "2026-08-16T16:23:40.345Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:chewy.com",
    "domain": "chewy.com",
    "generatedAt": "2026-08-16T16:24:06.249Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:chime.com",
    "domain": "chime.com",
    "generatedAt": "2026-08-16T16:22:49.886Z",
    "counts": {
      "domains": 12,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:chrobinson.com",
    "domain": "chrobinson.com",
    "generatedAt": "2026-08-16T16:23:11.329Z",
    "counts": {
      "domains": 5,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:classdojo.com",
    "domain": "classdojo.com",
    "generatedAt": "2026-08-16T16:23:47.969Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:cleanspark.com",
    "domain": "cleanspark.com",
    "generatedAt": "2026-08-16T16:27:19.942Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:cloverhealth.com",
    "domain": "cloverhealth.com",
    "generatedAt": "2026-08-16T16:22:42.549Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:coursera.org",
    "domain": "coursera.org",
    "generatedAt": "2026-08-16T16:23:37.538Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:datadoghq.com",
    "domain": "datadoghq.com",
    "generatedAt": "2026-08-16T16:23:25.427Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:dave.com",
    "domain": "dave.com",
    "generatedAt": "2026-08-16T16:22:54.469Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:definitivehc.com",
    "domain": "definitivehc.com",
    "generatedAt": "2026-08-16T16:22:33.484Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:degreed.com",
    "domain": "degreed.com",
    "generatedAt": "2026-08-16T16:23:47.820Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:donaldson.com",
    "domain": "donaldson.com",
    "generatedAt": "2026-08-16T16:22:32.191Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:doximity.com",
    "domain": "doximity.com",
    "generatedAt": "2026-08-16T16:22:39.709Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:dpr.com",
    "domain": "dpr.com",
    "generatedAt": "2026-08-16T16:23:59.090Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:duolingo.com",
    "domain": "duolingo.com",
    "generatedAt": "2026-08-16T16:23:41.487Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:enphase.com",
    "domain": "enphase.com",
    "generatedAt": "2026-08-16T16:27:07.923Z",
    "counts": {
      "domains": 1,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:etsy.com",
    "domain": "etsy.com",
    "generatedAt": "2026-08-16T16:24:07.391Z",
    "counts": {
      "domains": 7,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:everlane.com",
    "domain": "everlane.com",
    "generatedAt": "2026-08-16T16:27:06.524Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:evolenthealth.com",
    "domain": "evolenthealth.com",
    "generatedAt": "2026-08-16T16:22:47.069Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 4,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:exlservice.com",
    "domain": "exlservice.com",
    "generatedAt": "2026-08-16T16:23:11.193Z",
    "counts": {
      "domains": 2,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:figma.com",
    "domain": "figma.com",
    "generatedAt": "2026-08-16T16:23:24.448Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:firstsolar.com",
    "domain": "firstsolar.com",
    "generatedAt": "2026-08-16T16:27:08.170Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:flexport.com",
    "domain": "flexport.com",
    "generatedAt": "2026-08-16T16:23:09.499Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:fluenceenergy.com",
    "domain": "fluenceenergy.com",
    "generatedAt": "2026-08-16T16:27:18.799Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:fluor.com",
    "domain": "fluor.com",
    "generatedAt": "2026-08-16T16:23:54.119Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:forwardair.com",
    "domain": "forwardair.com",
    "generatedAt": "2026-08-16T16:23:16.963Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:fourkites.com",
    "domain": "fourkites.com",
    "generatedAt": "2026-08-16T16:23:22.278Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:franklinelectric.com",
    "domain": "franklinelectric.com",
    "generatedAt": "2026-08-16T16:22:21.184Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 1,
      "securityObservations": 4,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:fticonsulting.com",
    "domain": "fticonsulting.com",
    "generatedAt": "2026-08-16T16:23:10.795Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:generac.com",
    "domain": "generac.com",
    "generatedAt": "2026-08-16T16:22:21.152Z",
    "counts": {
      "domains": 5,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:genpact.com",
    "domain": "genpact.com",
    "generatedAt": "2026-08-16T16:23:02.990Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:gitlab.com",
    "domain": "gitlab.com",
    "generatedAt": "2026-08-16T16:23:25.069Z",
    "counts": {
      "domains": 6,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:glossier.com",
    "domain": "glossier.com",
    "generatedAt": "2026-08-16T16:27:06.506Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:graco.com",
    "domain": "graco.com",
    "generatedAt": "2026-08-16T16:22:21.322Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:gradescope.com",
    "domain": "gradescope.com",
    "generatedAt": "2026-08-16T16:23:58.316Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:graniteconstruction.com",
    "domain": "graniteconstruction.com",
    "generatedAt": "2026-08-16T16:23:54.440Z",
    "counts": {
      "domains": 11,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:grantthornton.com",
    "domain": "grantthornton.com",
    "generatedAt": "2026-08-16T16:23:08.423Z",
    "counts": {
      "domains": 3,
      "ipRanges": 5,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:guardanthealth.com",
    "domain": "guardanthealth.com",
    "generatedAt": "2026-08-16T16:22:33.429Z",
    "counts": {
      "domains": 2,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:guild.com",
    "domain": "guild.com",
    "generatedAt": "2026-08-16T16:23:41.962Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:hashicorp.com",
    "domain": "hashicorp.com",
    "generatedAt": "2026-08-16T16:23:25.402Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:hdrinc.com",
    "domain": "hdrinc.com",
    "generatedAt": "2026-08-16T16:24:01.466Z",
    "counts": {
      "domains": 2,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:healthcatalyst.com",
    "domain": "healthcatalyst.com",
    "generatedAt": "2026-08-16T16:22:33.987Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:heliosgear.com",
    "domain": "heliosgear.com",
    "generatedAt": "2026-08-16T16:22:31.192Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 3,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 5
    }
  },
  {
    "id": "discovery:henselphelps.com",
    "domain": "henselphelps.com",
    "generatedAt": "2026-08-16T16:24:00.573Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:hologic.com",
    "domain": "hologic.com",
    "generatedAt": "2026-08-16T16:22:29.186Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:hubgroup.com",
    "domain": "hubgroup.com",
    "generatedAt": "2026-08-16T16:23:15.641Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:huronconsultinggroup.com",
    "domain": "huronconsultinggroup.com",
    "generatedAt": "2026-08-16T16:22:57.372Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:instructure.com",
    "domain": "instructure.com",
    "generatedAt": "2026-08-16T16:23:40.430Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:iqvia.com",
    "domain": "iqvia.com",
    "generatedAt": "2026-08-16T16:23:04.410Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:jacobs.com",
    "domain": "jacobs.com",
    "generatedAt": "2026-08-16T16:23:53.161Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:kbr.com",
    "domain": "kbr.com",
    "generatedAt": "2026-08-16T16:23:54.347Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:kennametal.com",
    "domain": "kennametal.com",
    "generatedAt": "2026-08-16T16:22:21.413Z",
    "counts": {
      "domains": 17,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:khanacademy.org",
    "domain": "khanacademy.org",
    "generatedAt": "2026-08-16T16:23:46.637Z",
    "counts": {
      "domains": 16,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:kiewit.com",
    "domain": "kiewit.com",
    "generatedAt": "2026-08-16T16:24:00.877Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:kornferry.com",
    "domain": "kornferry.com",
    "generatedAt": "2026-08-16T16:22:56.862Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:landstar.com",
    "domain": "landstar.com",
    "generatedAt": "2026-08-16T16:23:16.870Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:lendingclub.com",
    "domain": "lendingclub.com",
    "generatedAt": "2026-08-16T16:22:48.474Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:lennox.com",
    "domain": "lennox.com",
    "generatedAt": "2026-08-16T16:22:32.068Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:lincolnelectric.com",
    "domain": "lincolnelectric.com",
    "generatedAt": "2026-08-16T16:22:21.325Z",
    "counts": {
      "domains": 13,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 3
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:linear.app",
    "domain": "linear.app",
    "generatedAt": "2026-08-16T16:23:33.678Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:marqeta.com",
    "domain": "marqeta.com",
    "generatedAt": "2026-08-16T16:22:41.886Z",
    "counts": {
      "domains": 4,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:masimo.com",
    "domain": "masimo.com",
    "generatedAt": "2026-08-16T16:22:32.037Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:mercury.com",
    "domain": "mercury.com",
    "generatedAt": "2026-08-16T16:22:48.229Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:milwaukeetool.com",
    "domain": "milwaukeetool.com",
    "generatedAt": "2026-08-16T16:22:32.064Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:mortenson.com",
    "domain": "mortenson.com",
    "generatedAt": "2026-08-16T16:23:59.814Z",
    "counts": {
      "domains": 4,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:mx.com",
    "domain": "mx.com",
    "generatedAt": "2026-08-16T16:22:54.754Z",
    "counts": {
      "domains": 8,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:natera.com",
    "domain": "natera.com",
    "generatedAt": "2026-08-16T16:22:33.278Z",
    "counts": {
      "domains": 2,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:nerdwallet.com",
    "domain": "nerdwallet.com",
    "generatedAt": "2026-08-16T16:22:52.821Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:nerdy.com",
    "domain": "nerdy.com",
    "generatedAt": "2026-08-16T16:23:43.947Z",
    "counts": {
      "domains": 2,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:newsela.com",
    "domain": "newsela.com",
    "generatedAt": "2026-08-16T16:23:57.927Z",
    "counts": {
      "domains": 1,
      "ipRanges": 6,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 6,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:nexteraenergy.com",
    "domain": "nexteraenergy.com",
    "generatedAt": "2026-08-16T16:27:17.397Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:nextracker.com",
    "domain": "nextracker.com",
    "generatedAt": "2026-08-16T16:27:18.739Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:nordson.com",
    "domain": "nordson.com",
    "generatedAt": "2026-08-16T16:22:21.250Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:notion.so",
    "domain": "notion.so",
    "generatedAt": "2026-08-16T16:23:33.738Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 7
    }
  },
  {
    "id": "discovery:odfl.com",
    "domain": "odfl.com",
    "generatedAt": "2026-08-16T16:23:12.420Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:ormat.com",
    "domain": "ormat.com",
    "generatedAt": "2026-08-16T16:27:19.719Z",
    "counts": {
      "domains": 13,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 1,
      "securityObservations": 4,
      "riskObservations": 3
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:oscarhealth.com",
    "domain": "oscarhealth.com",
    "generatedAt": "2026-08-16T16:22:33.280Z",
    "counts": {
      "domains": 2,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 4,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 7
    }
  },
  {
    "id": "discovery:outschool.com",
    "domain": "outschool.com",
    "generatedAt": "2026-08-16T16:23:47.563Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:pentair.com",
    "domain": "pentair.com",
    "generatedAt": "2026-08-16T16:27:06.534Z",
    "counts": {
      "domains": 15,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:perficient.com",
    "domain": "perficient.com",
    "generatedAt": "2026-08-16T16:23:05.906Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:phreesia.com",
    "domain": "phreesia.com",
    "generatedAt": "2026-08-16T16:22:35.648Z",
    "counts": {
      "domains": 2,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:plaid.com",
    "domain": "plaid.com",
    "generatedAt": "2026-08-16T16:22:40.811Z",
    "counts": {
      "domains": 4,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:plugpower.com",
    "domain": "plugpower.com",
    "generatedAt": "2026-08-16T16:27:14.531Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:postman.com",
    "domain": "postman.com",
    "generatedAt": "2026-08-16T16:23:33.805Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:powerschool.com",
    "domain": "powerschool.com",
    "generatedAt": "2026-08-16T16:23:41.370Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:priviahealth.com",
    "domain": "priviahealth.com",
    "generatedAt": "2026-08-16T16:22:33.465Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:procore.com",
    "domain": "procore.com",
    "generatedAt": "2026-08-16T16:23:50.351Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:progyny.com",
    "domain": "progyny.com",
    "generatedAt": "2026-08-16T16:22:39.889Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:project44.com",
    "domain": "project44.com",
    "generatedAt": "2026-08-16T16:23:20.908Z",
    "counts": {
      "domains": 2,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:protolabs.com",
    "domain": "protolabs.com",
    "generatedAt": "2026-08-16T16:22:32.013Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:ramp.com",
    "domain": "ramp.com",
    "generatedAt": "2026-08-16T16:22:48.202Z",
    "counts": {
      "domains": 2,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:retool.com",
    "domain": "retool.com",
    "generatedAt": "2026-08-16T16:23:33.208Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:rgp.com",
    "domain": "rgp.com",
    "generatedAt": "2026-08-16T16:23:01.761Z",
    "counts": {
      "domains": 6,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:roberthalf.com",
    "domain": "roberthalf.com",
    "generatedAt": "2026-08-16T16:22:55.854Z",
    "counts": {
      "domains": 14,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:rothys.com",
    "domain": "rothys.com",
    "generatedAt": "2026-08-16T16:27:17.429Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:ruggable.com",
    "domain": "ruggable.com",
    "generatedAt": "2026-08-16T16:27:17.427Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:ryder.com",
    "domain": "ryder.com",
    "generatedAt": "2026-08-16T16:23:15.427Z",
    "counts": {
      "domains": 15,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:saia.com",
    "domain": "saia.com",
    "generatedAt": "2026-08-16T16:23:14.190Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:schneider.com",
    "domain": "schneider.com",
    "generatedAt": "2026-08-16T16:23:19.031Z",
    "counts": {
      "domains": 4,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:segment.com",
    "domain": "segment.com",
    "generatedAt": "2026-08-16T16:23:34.966Z",
    "counts": {
      "domains": 2,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:sentry.io",
    "domain": "sentry.io",
    "generatedAt": "2026-08-16T16:23:33.957Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:sofi.com",
    "domain": "sofi.com",
    "generatedAt": "2026-08-16T16:22:42.024Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:stantec.com",
    "domain": "stantec.com",
    "generatedAt": "2026-08-16T16:24:02.280Z",
    "counts": {
      "domains": 2,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:stem.com",
    "domain": "stem.com",
    "generatedAt": "2026-08-16T16:27:14.420Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:sunnova.com",
    "domain": "sunnova.com",
    "generatedAt": "2026-08-16T16:27:18.642Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:sunpower.com",
    "domain": "sunpower.com",
    "generatedAt": "2026-08-16T16:27:14.661Z",
    "counts": {
      "domains": 1,
      "ipRanges": 8,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:sunrun.com",
    "domain": "sunrun.com",
    "generatedAt": "2026-08-16T16:27:17.429Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:teladochealth.com",
    "domain": "teladochealth.com",
    "generatedAt": "2026-08-16T16:22:22.758Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:tempus.com",
    "domain": "tempus.com",
    "generatedAt": "2026-08-16T16:22:39.973Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:thirdlove.com",
    "domain": "thirdlove.com",
    "generatedAt": "2026-08-16T16:27:06.505Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:thoughtworks.com",
    "domain": "thoughtworks.com",
    "generatedAt": "2026-08-16T16:23:04.842Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:timken.com",
    "domain": "timken.com",
    "generatedAt": "2026-08-16T16:22:32.199Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:trex.com",
    "domain": "trex.com",
    "generatedAt": "2026-08-16T16:22:21.172Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:turnerconstruction.com",
    "domain": "turnerconstruction.com",
    "generatedAt": "2026-08-16T16:23:59.536Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 4,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:tutorperini.com",
    "domain": "tutorperini.com",
    "generatedAt": "2026-08-16T16:23:57.082Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 2,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:twilio.com",
    "domain": "twilio.com",
    "generatedAt": "2026-08-16T16:23:27.384Z",
    "counts": {
      "domains": 1,
      "ipRanges": 3,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:udemy.com",
    "domain": "udemy.com",
    "generatedAt": "2026-08-16T16:23:46.392Z",
    "counts": {
      "domains": 2,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:upstart.com",
    "domain": "upstart.com",
    "generatedAt": "2026-08-16T16:22:49.078Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 5,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:uships.com",
    "domain": "uships.com",
    "generatedAt": "2026-08-16T16:23:30.854Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 1,
      "securityObservations": 3,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 5
    }
  },
  {
    "id": "discovery:vercel.com",
    "domain": "vercel.com",
    "generatedAt": "2026-08-16T16:23:33.403Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:warbyparker.com",
    "domain": "warbyparker.com",
    "generatedAt": "2026-08-16T16:24:05.939Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:watts.com",
    "domain": "watts.com",
    "generatedAt": "2026-08-16T16:22:21.195Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:wayfair.com",
    "domain": "wayfair.com",
    "generatedAt": "2026-08-16T16:24:07.389Z",
    "counts": {
      "domains": 5,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:wearefigs.com",
    "domain": "wearefigs.com",
    "generatedAt": "2026-08-16T16:24:07.691Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 3,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 6
    }
  },
  {
    "id": "discovery:werner.com",
    "domain": "werner.com",
    "generatedAt": "2026-08-16T16:23:17.765Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:westmonroe.com",
    "domain": "westmonroe.com",
    "generatedAt": "2026-08-16T16:23:09.047Z",
    "counts": {
      "domains": 1,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 5,
      "riskObservations": 2
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:wns.com",
    "domain": "wns.com",
    "generatedAt": "2026-08-16T16:23:02.562Z",
    "counts": {
      "domains": 1,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 1,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:xpo.com",
    "domain": "xpo.com",
    "generatedAt": "2026-08-16T16:23:12.588Z",
    "counts": {
      "domains": 17,
      "ipRanges": 1,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 1
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:yeti.com",
    "domain": "yeti.com",
    "generatedAt": "2026-08-16T16:27:06.524Z",
    "counts": {
      "domains": 6,
      "ipRanges": 2,
      "publicServices": 1,
      "technologies": 3,
      "securityObservations": 5,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  },
  {
    "id": "discovery:zapier.com",
    "domain": "zapier.com",
    "generatedAt": "2026-08-16T16:23:30.428Z",
    "counts": {
      "domains": 1,
      "ipRanges": 4,
      "publicServices": 1,
      "technologies": 4,
      "securityObservations": 6,
      "riskObservations": 0
    },
    "coverage": {
      "checks": 9,
      "observed": 8
    }
  }
];
